import { jsx as _jsx } from "react/jsx-runtime";
import SkeletonLoader from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export function Skeleton(props) {
    return (_jsx(SkeletonLoader, { baseColor: "#E9E8E7", highlightColor: "#F4F3F3", ...props }));
}
